import { render, staticRenderFns } from "./roleDetail.vue?vue&type=template&id=ad522788&scoped=true"
import script from "./roleDetail.vue?vue&type=script&lang=js"
export * from "./roleDetail.vue?vue&type=script&lang=js"
import style0 from "./roleDetail.vue?vue&type=style&index=0&id=ad522788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad522788",
  null
  
)

export default component.exports